import { render, staticRenderFns } from "./BaseButtonTrash.vue?vue&type=template&id=5b842a0f&scoped=true&"
import script from "./BaseButtonTrash.vue?vue&type=script&lang=js&"
export * from "./BaseButtonTrash.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonTrash.vue?vue&type=style&index=0&id=5b842a0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b842a0f",
  null
  
)

export default component.exports